import { render, staticRenderFns } from "./ServiceContractMaterials.vue?vue&type=template&id=f2f18a94"
import script from "./ServiceContractMaterials.vue?vue&type=script&lang=js"
export * from "./ServiceContractMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports